import { IFileAddRequest } from '../../../model/scp/base/request/file-add-request';
import { ValidationErrors, isBlank, isEmptyId } from '../../../utils/validation';

export type FileAttachmentField = 'documentTypeId' | 'title' | 'document';

export function validateFileAttachment(request: IFileAddRequest): ValidationErrors<FileAttachmentField> {
    const errors: ValidationErrors<FileAttachmentField> = {};
    if (isEmptyId(request.documentTypeId)) errors.documentTypeId = 'Tipo de arquivo é obrigatório';
    if (isBlank(request.title)) errors.title = 'Título é obrigatório';
    if (!request.document) errors.document = 'Arquivo é obrigatório';
    return errors;
}
